<div>
	<input
		[value]="value"
		nbInput
		#quantity
		type="number"
		placeholder="{{ 'INVENTORY_PAGE.QUANTITY' | translate }}"
	/>
</div>
